import {type TranslationObject} from '@colonist/i18n'
import {createDivIn, createHeaderIn, createParagraphIn} from '../../../shared/scripts/ui_utils/DomUtils.ts'

export class AnnouncementView {
    constructor(title: TranslationObject, announcements: string[], container: HTMLElement, divClass: string, headerClass: string, bodyClass: string) {
        if(announcements.length == 0) return

        const pndiv = createDivIn(container, divClass)
        const headerDiv = createDivIn(pndiv, headerClass)
        const titleH = createHeaderIn(headerDiv, title, 'pn-title-announcement', '', 'H2')
        const bodyDiv = createDivIn(pndiv, bodyClass, '')

        for(const ann of announcements) {
            createParagraphIn(bodyDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: ann, interpolation: {escapeValue: false}}}, '')
        }
    }
}
